// @flow
import styled from "styled-components";
import RawPopup from "../Popup";
import RawLink from "../../Link";
import _Money from "../../../Money";

import img from "../../../../images/tournament-description-bg.png";

export const Popup = styled(RawPopup)`
  width: 100%;
  background-image: url(${img});
  background-color: ${({ theme }) => theme.tournamentPopupBgDark};
  background-size: cover;
  overflow: hidden;

  @media (min-width: 960px) {
    max-width: 691px;
    padding: 25px 0;
  }

  @media (max-width: 959px) {
    padding: 16px 0;
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  @media (max-width: 959px) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    align-content: space-between;
    justify-content: space-between;
    flex: 1;
    height: 100%;
    overflow: auto;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const Text = styled.div`
  width: 100%;
  padding: 0 16px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.lightWhiteForeground};
`;

export const Container = styled.div`
  @media (max-width: 959px) {
    width: 100%;
  }
`;
export const LinkContainer = styled(Container)`
  flex-shrink: 0;
  align-self: flex-end;
`;

export const Link = styled(RawLink)`
  margin-top: 0;
`;

export const Info = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  padding: 14px 32px;
  margin-bottom: 27px;
  background-color: ${({ theme }) => theme.tournamentPopupBgLight};

  @media (max-width: 479px) {
    padding: 14px 20px;
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const InfoItems = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 959px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const MoneyContainer = styled.div`
  margin: 0 5px;
  font-size: 14px;
  font-weight: 700;

  @media (max-width: 959px) {
    font-size: 12px;
  }
`;

export const Value = styled(_Money.Value)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme }) => theme.foreground};
`;

export const Currency = styled(_Money.Symbol)`
  font-weight: 700;
  margin: 0 2px;
  color: ${({ theme }) => theme.accent};
`;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/styles.js